import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { UtilsService } from '../utils.service';
import ContextProvider from 'src/app/servizi/contextProvider';
import { ConfigService } from '../config/config.service';

@Injectable({
   providedIn: 'root'
})


export class GestioneUtentiService {

   utentiSubject = new Subject();

   userData: any;
   userPermissions: number[] = new Array();
   userFeatures: number[] = new Array();

   contextApplication;

   /** Costruttore */
   constructor(
      private utils: UtilsService,
      private configService: ConfigService,
   ) { 
      this.contextApplication = this.configService.getConfigGlobale().context.application;
   }

   /**
   * @param parameters "{ids=[1,2,3]}"
   */
   userGet(parameters: { [param: string]: ReadonlyArray<string | number | boolean> }): Observable<unknown> {
      return this.utils.getRequest(this.utils.creaURL('user', 'get'), parameters);
   }

   userAdd(data: any): Observable<any> {
      return this.utils.postRequest(this.utils.creaURL('user', 'add'), data);
   }

   userUpdate(body: any, httpOptions?: any): Observable<unknown> {
      return this.utils.putRequest(this.utils.creaURL('user', 'update'), body, httpOptions);
   }

   userDelete(data: any): Observable<any> {
      return this.utils.deleteRequest(this.utils.creaURL('user', 'delete'), data);
   }

   // ------------------------------------------------------------------------------------------

   /**
   * @param parameters "{tokens=[123abcd121gfgdfb34abcs,123abcd121gfgdfb34abcs]}"
   */
   userGetByToken(parameters: { [param: string]: ReadonlyArray<string> }): Observable<unknown> {
      
      console.log("this.configService.getConfigGlobale() : ", this.configService.getConfigGlobale())
      console.log("this.contextApplication : ", this.contextApplication)

      if(this.contextApplication == "NAM"){
         console.log("Chiamata GET - NAM")
         return this.utils.getRequest(this.utils.creaURL('user', 'getByToken'), parameters);
      } 
      // Es. INWIT
      else {
         console.log("Chiamata POST - INWIT")
         return this.utils.postRequest(this.utils.creaURL('user', 'getByToken'), parameters); // Microsoft Azure AD SSO
      }
   }

   // ------------------------------------------------------------------------------------------

   /**
   * User set properties
   */
   userSetProperties(user: any) {
      // USER's PROPERTIES & CREDENTIALS
      this.userData = { ...user.properties, ...user.credentials };
      this.userData["groups"] = user.groups;
   }

   /**
   * User get properties
   */
   userGetProperties() {
      // USER's PROPERTIES & CREDENTIALS
      return this.userData;
   }

   userSetPermissions(data) {

      // PERMISSIONS
      data.forEach(el => {
         this.userPermissions.push(el.name);

         // FEATURES
         if(el.features){
            el.features.forEach(f => {
               this.userFeatures.push(f.name);
            })
         };
      });

      // console.log("SET PERMISSIONS DONE", this.userFeatures)
   }

   /**
    * To check if the user has the specific feature
    */
   isEnabled(toFind) {
      if (!this.userFeatures || this.userFeatures.length === 0) {
         return false;
      }

      if (this.userFeatures.find((el) => el == toFind)) {
         return true;
      } else {
         return false;
      }
   }

   clearUserInfo(){ 

      this.userData = undefined;
      this.userPermissions = new Array();
      this.userFeatures = new Array();
   }

   /**
   * Users list
   */
   utentiList(): Observable<unknown> {
      return this.utils.getRequest(this.utils.creaURL('giornaleLavori', 'usersList'), {});
   }

   
   /**
    * To check if the user is in specific group
    */
   userIsInGroup(toFind){
      if (this.userData.groups.find(group => group.name == toFind)) {
         return true;
      } else {
         return false;
      }
   }
}